export const  propertyData = [

  {
    id:1,
    property_name:'Palm Harbor',
    property_price:'2000',
    property_image:'https://cdn.pixabay.com/photo/2017/04/10/22/28/residence-2219972_960_720.jpg',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'30-09-2022',
  },
  {
    id:2,
    property_name:'Aalm natra',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'29-09-2022',
  },{
    id:3,
    property_name:'kasi house',
    property_price:'6000',
    property_image:'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'27-09-2022',
  },{
    id:4,
    property_name:'wasixk house',
    property_price:'7200',
    property_image:'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'29-09-2022'
  },{
    id:5,
    property_name:'mirosee',
    property_price:'2200',
    property_image:'https://images.pexels.com/photos/1029599/pexels-photo-1029599.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'27-09-2022',
  },{
    id:6,
    property_name:'bwarser Bin',
    property_price:'4200',
    property_image:'https://images.pexels.com/photos/259588/pexels-photo-259588.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'27-09-2022',
  },{
    id:7,
    property_name:'Palmor',
    property_price:'6200',
    property_image:'https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'17-09-2022',
  },{
    id:8,
    property_name:'Harbor',
    property_price:'9200',
    property_image:'https://images.pexels.com/photos/276724/pexels-photo-276724.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'17-09-2022',
  },{
    id:9,
    property_name:'house infbor',
    property_price:'7092',
    property_image:'https://images.pexels.com/photos/2635038/pexels-photo-2635038.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'17-09-2022'
  },{
    id:10,
    property_name:'Harbor house',
    property_price:'6290',
    property_image:'https://images.pexels.com/photos/280229/pexels-photo-280229.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'17-09-2022',
  },{
    id:11,
    property_name:'apart house',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/1643389/pexels-photo-1643389.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'24-08-2022',
  },{
    id:12,
    property_name:'karvath house',
    property_price:'4400',
    property_image:'https://images.pexels.com/photos/1396132/pexels-photo-1396132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Delhi',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'14-09-2022',
  },  {
    id:13,
    property_name:'arvindha Harbor',
    property_price:'2000',
    property_image:'https://images.pexels.com/photos/1396132/pexels-photo-1396132.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'13-09-2022',
  },
  {
    id:14,
    property_name:'Akrvah Harbor',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/731082/pexels-photo-731082.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'11-09-2022',
  },{
    id:15,
    property_name:'vijaya house',
    property_price:'6000',
    property_image:'https://images.pexels.com/photos/221540/pexels-photo-221540.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'11-09-2022',
  },{
    id:16,
    property_name:'avinya house',
    property_price:'7200',
    property_image:'https://images.pexels.com/photos/208736/pexels-photo-208736.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'11-09-2022',
  },{
    id:17,
    property_name:'marnaie',
    property_price:'2200',
    property_image:'https://images.pexels.com/photos/259962/pexels-photo-259962.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'11-09-2022',
  },{
    id:18,
    property_name:'svranam house',
    property_price:'4200',
    property_image:'https://images.pexels.com/photos/209296/pexels-photo-209296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'10-09-2022',
  },{
    id:19,
    property_name:'rama house',
    property_price:'6200',
    property_image:'https://images.pexels.com/photos/277667/pexels-photo-277667.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'10-09-2022',
  },{
    id:20,
    property_name:'sitas mansion',
    property_price:'9200',
    property_image:'https://images.pexels.com/photos/259751/pexels-photo-259751.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'10-09-2022',
  },{
    id:21,
    property_name:'blamns hers',
    property_price:'7092',
    property_image:'https://images.pexels.com/photos/323775/pexels-photo-323775.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'10-09-2022',
  },{
    id:22,
    property_name:'ramana lanka',
    property_price:'6290',
    property_image:'https://images.pexels.com/photos/323772/pexels-photo-323772.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'24-08-2022',
  },{
    id:23,
    property_name:'apart house',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/53610/large-home-residential-house-architecture-53610.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'09-09-2022',
  },{
    id:24,
    property_name:'karvath house',
    property_price:'4400',
    property_image:'https://images.pexels.com/photos/221024/pexels-photo-221024.jpeg',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Hyderabad',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'08-09-2022',
  },{
    id:25,
    property_name:'Palm Harbor',
    property_price:'2000',
    property_image:'https://images.pexels.com/photos/2724748/pexels-photo-2724748.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'07-09-2022',
  },
  {
    id:26,
    property_name:'Aalm Harbor',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/2121120/pexels-photo-2121120.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'05-09-2022',
  },{
    id:27,
    property_name:'kasi house',
    property_price:'6000',
    property_image:'https://images.pexels.com/photos/2850472/pexels-photo-2850472.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'05-09-2022',
  },{
    id:28,
    property_name:'wasixk house',
    property_price:'7200',
    property_image:'https://images.pexels.com/photos/463734/pexels-photo-463734.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'04-09-2022',
  },{
    id:29,
    property_name:'mirosee',
    property_price:'2200',
    property_image:'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'04-09-2022',
  },{
    id:30,
    property_name:'bwarser Bin',
    property_price:'4200',
    property_image:'https://images.pexels.com/photos/1475938/pexels-photo-1475938.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'03-09-2022',
  },{
    id:31,
    property_name:'Palmor',
    property_price:'6200',
    property_image:'https://images.pexels.com/photos/453201/pexels-photo-453201.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'03-09-2022',
  },{
    id:32,
    property_name:'Harbor',
    property_price:'9200',
    property_image:'https://images.pexels.com/photos/275484/pexels-photo-275484.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'03-09-2022',
  },{
    id:33,
    property_name:'blamns hers',
    property_price:'7092',
    property_image:'https://images.pexels.com/photos/3214064/pexels-photo-3214064.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'01-09-2022',
  },{
    id:34,
    property_name:'ramana lanka',
    property_price:'6290',
    property_image:'https://images.pexels.com/photos/2988860/pexels-photo-2988860.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'01-09-2022',
  },{
    id:35,
    property_name:'apart house',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/271816/pexels-photo-271816.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'31-08-2022',
  },{
    id:36,
    property_name:'karvath house',
    property_price:'4400',
    property_image:'https://images.pexels.com/photos/2155202/pexels-photo-2155202.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Pune',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'29-08-2022',
  },{
    id:37,
    property_name:'Palm Harbor',
    property_price:'2000',
    property_image:'https://images.pexels.com/photos/276554/pexels-photo-276554.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'29-08-2022',
  },
  {
    id:38,
    property_name:'Aalm Harbor',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/2893177/pexels-photo-2893177.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'28-08-2022',
  },{
    id:39,
    property_name:'kasi house',
    property_price:'6000',
    property_image:'https://images.pexels.com/photos/259580/pexels-photo-259580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'28-08-2022',
  },{
    id:40,
    property_name:'wasixk house',
    property_price:'7200',
    property_image:'https://images.pexels.com/photos/460695/pexels-photo-460695.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'Houses',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'27-08-2022',
  },{
    id:41,
    property_name:'mirosee',
    property_price:'2200',
    property_image:'https://cdn.pixabay.com/photo/2017/04/10/22/28/residence-2219972_960_720.jpg',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'26-08-2022',
  },{
    id:42,
    property_name:'bwarser Bin',
    property_price:'4200',
    property_image:'https://images.pexels.com/photos/2326926/pexels-photo-2326926.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'26-08-2022',
  },{
    id:43,
    property_name:'Palmor',
    property_price:'6200',
    property_image:'https://images.pexels.com/photos/53782/pexels-photo-53782.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'26-08-2022',
  },{
    id:44,
    property_name:'Harbor',
    property_price:'9200',
    property_image:'https://images.pexels.com/photos/2305747/pexels-photo-2305747.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'flat',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'31-08-2022',
  },{
    id:45,
    property_name:'house infbor',
    property_price:'7092',
    property_image:'https://images.pexels.com/photos/271618/pexels-photo-271618.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'29-08-2022',
  },{
    id:46,
    property_name:'Harbor house',
    property_price:'6290',
    property_image:'https://cdn.pixabay.com/photo/2017/04/10/22/28/residence-2219972_960_720.jpg',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'30-08-2022',
  },{
    id:47,
    property_name:'apart house',
    property_price:'3200',
    property_image:'https://images.pexels.com/photos/7598116/pexels-photo-7598116.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:false,
    avilability_date:'22-08-2022',
  },{
    id:48,
    property_name:'karvath house',
    property_price:'4400',
    property_image:'https://images.pexels.com/photos/7587880/pexels-photo-7587880.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    property_type:'appartment',
    propertyAddress:'5/227 kolimi street ',
    property_country:'IN',
    property_city:'Bengaluru',
    property_beds:3,
    property_bathrooms:2,
    property_length:5,
    property_width:7,
    favourite:false,
    popular:true,
    avilability_date:'24-08-2022',
  }




]